import TrustedPartnersScreen from "@/screens/loans/TrustedPartnersScreen"
import { useLoanContext } from "@/screens/loans/components/LoanContext"

export const PartnersScreen = () => {
  const { loanId } = useLoanContext()

  return <TrustedPartnersScreen loanId={loanId} />
}

export default PartnersScreen
